<template>
  <div>
    <data-table
      table-ref="insurance-table"

      title="Insurance"
      icon="fa fa-shield-alt"

      hide-org-badge
      :show-search="false"

      :url="'/insurance/site/' + rowData.id"

      :fields="fields">

    </data-table>


  </div>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {

mixins: [DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  methods: {
    formatStatus (value, inclText = false) {
      var icon = ''
      var color = 'darkgrey'

      if (value === 'Completed') {
        color = 'seagreen'
        icon = 'check-square'
      }

      if (value === 'KIV') {
        icon = 'clock'
      }

      if (value === 'Pending Payment') {
        color = 'goldenrod'
        icon = 'credit-card'
      }

      if (value === 'Approved') {
        color = 'seagreen'
        icon = 'thumbs-up'
      }

      if (value === 'Active') {
        color = 'slateblue'
        icon = 'check'
      }

      if (value === 'Terminated') {
        color = 'indianred'
        icon = 'bolt'
      }

      if (value === 'Pending') {
        color = 'goldenrod'
        icon = 'random'
      }

      return '<b><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '&nbsp;</i><span style="color: ' + color + ';">&nbsp;' +
        (this.isMobile ? '' : (inclText ? value : '')) +
        '</span></b>'
    }
  },

  data () {
    return {
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'policyType',
          title: 'Type',
          sortField: 'policyType'
        },
        {
          name: 'policyNo',
          title: 'Policy #',
          sortField: 'policyNo'
        },
        {
          name: 'provider.shortName',
          title: 'Provider',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'beneficary.shortName',
          title: 'Beneficiary',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'premium',
          title: 'Premium',
          sortField: 'premium',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber
        },
        {
          name: 'frequency',
          title: 'Frequency',
          sortField: 'frequency',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'coverageStart',
          title: 'Started On',
          sortField: 'coverageStart',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate
        },
        {
          name: 'coverageEnd',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate
        },
     ]
  }
}
}

</script>
